import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { PolicySelectorField } from "../PolicySelector";
export const ProspectIntelligencePermission = () => {
    const intl = useIntl();
    const policyOptions = [
        {
            value: [],
            label: intl.formatMessage(messages.prospectIntelligencePermissionOptionView),
        },
        {
            value: ["prospect_intelligence_read" /* PolicyActions.PROSPECT_INTELLIGENCE_READ */],
            label: intl.formatMessage(messages.prospectIntelligencePermissionOptionDeny),
        },
    ];
    return (React.createElement(PolicySelectorField, { label: intl.formatMessage(messages.prospectIntelligencePermissionLabel), policyOptions: policyOptions, id: "deny.prospectIntelligence" }));
};
export default ProspectIntelligencePermission;
